import { USER_PROFILE_FETCH_REQUEST, USER_PROFILE_FETCH_SUCCESS, USER_PROFILE_FETCH_FAILURE } from './types';

const initialState = {
    loading: false,
    profile: {},
    error: ''
}

const profile = (state = initialState, action) => {
    switch (action.type) {
        case USER_PROFILE_FETCH_REQUEST:
            return {
                loading: true,
                profile: {},
                error: '',
            }
        case USER_PROFILE_FETCH_SUCCESS:
            return {
                loading: false,
                profile: action.payload,
                error: ''
            }
        case USER_PROFILE_FETCH_FAILURE:
            return {
                loading: false,
                profile: {},
                error: action.payload
            }
        default:
            return state
    }
}

export default profile;